export enum CourseTableType {
    ANY = 1,
    ALL = 2,
    ONE = 3
}